module.exports = __webpack_public_path__ + "media/components/Agencies/Influencers/Shared/download-b08e3c8a571e42d1efad5702dbf664c1.svg";